import React, { useState, useEffect } from "react";
import { MoonLoader } from "react-spinners";
import { getLoadingSequence } from "../../../config/loadingMessages";

const LoadingPopup = ({
  adType,
  imageType,
  projectData,
  isVisible,
  onCycleComplete
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
  const [messages, setMessages] = useState([]);
  const [cycleCount, setCycleCount] = useState(0);

  useEffect(() => {
    if (isVisible) {
      // Get the loading sequence when popup becomes visible
      const sequence = getLoadingSequence(adType, projectData);
      setMessages(sequence);
      setCurrentMessageIndex(0);
      setCycleCount(0);
    }
  }, [isVisible, adType, projectData]);

  useEffect(() => {
    if (!isVisible || messages.length === 0) return;

    // Set up timer to advance to next message
    const currentMessage = messages[currentMessageIndex];
    const timer = setTimeout(() => {
      // Check if we've reached the last message
      if (currentMessageIndex >= messages.length - 1) {
        // Restart from beginning
        setCurrentMessageIndex(0);
        const newCycleCount = cycleCount + 1;
        setCycleCount(newCycleCount);

        // For AI-generated images only, notify parent after 3 cycles
        const isAiGeneratedImage = imageType === "aiGeneratedImage";
        if (isAiGeneratedImage && newCycleCount >= 3 && onCycleComplete) {
          onCycleComplete();
        }
      } else {
        // Move to next message
        setCurrentMessageIndex((prev) => prev + 1);
      }
    }, currentMessage.duration);

    return () => clearTimeout(timer);
  }, [
    currentMessageIndex,
    messages,
    isVisible,
    cycleCount,
    imageType,
    onCycleComplete
  ]);

  if (!isVisible || messages.length === 0) return null;

  const currentMessage = messages[currentMessageIndex];

  return (
    <div className="fixed inset-0 z-[100000000] flex items-center justify-center bg-blurDark backdrop-blur-sm">
      <div className="flex max-w-[500px] flex-col items-center rounded-3xl bg-white px-12 py-10 shadow-2xl">
        {/* Loader Spinner */}
        <MoonLoader loading={true} color="#17C471" size={60} />

        {/* Loading Message */}
        <div className="mt-8 text-center">
          <p className="font-InterSemibold text-ft18-25.2 text-grey-12">
            {currentMessage.message}
          </p>
        </div>

        {/* Progress Indicator */}
        <div className="mt-6 flex gap-2">
          {messages.map((_, index) => (
            <div
              key={index}
              className={`size-2 rounded-full transition-all duration-300 ${
                index === currentMessageIndex
                  ? "w-8 bg-green-12"
                  : index < currentMessageIndex
                    ? "bg-green-12"
                    : "bg-grey-9"
              }`}
            />
          ))}
        </div>

        {/* Phase Label */}
        <p className="mt-4 font-InterRegular text-ft14-20 text-grey-14">
          Step {currentMessageIndex + 1} of {messages.length}
        </p>
      </div>
    </div>
  );
};

export default LoadingPopup;
